export default __webpack_public_path__ + "static/media/barChartbackground.d292716f.png";